<!-- 特典を探す 特大カテゴリ -->
<template>
  <div class="crly-a-common-search-keyword-category-btn">
    <button @click="clickBtn" :class="{ active: category === active }">
      {{ $t(`common.category.cat${category}`) }}
    </button>
  </div>
</template>

<script>
export default {
  name: "CrlyAtomsCommonSearchKeywordCategoryBtn",
  props: {
    /**
     * カテゴリ
     */
    category: {
      type: Number,
      default: null
    },
    /**
     * 選択中のカテゴリ
     */
    active: {
      type: Number,
      default: null
    }
  },
  methods: {
    /**
     * カテゴリクリックイベント
     */
    clickBtn() {
      this.$emit("clickCatBtn", this.category);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@crly/assets/css/atoms/common/search/keyword/categoryBtn.scss";
</style>
